export default __webpack_public_path__ + "static/media/O-129.118e5a07.png";